import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicConditionInscription = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: "S'inscrire des compétitions", link: '/topics/rechercher/sincrire-competition-index'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Lors de votre inscription à une compétition, nous avons besoin de connaître certaines informations de base vous concernant.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Nous avons besoin au minimum des informations suivantes, pour vous et pour tous les memebres de votre équipe : 
              </p>
              <ul>
                <li className="pl-8 mb-8"><p className="help-text">Nom et prénom</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Adresse e-mail</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Date de naissance</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Numéro de téléphone</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Genre</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Tailles si la compétition propose des goodies</p></li>
              </ul>
              <p className="help-text">
                Pour rappel, toutes ces informations peuvent être pré-remplies si vous compléter votre
                <a target='_blank' className="link" href={`/topics/compte/14`}>profil.</a>
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Nous sommes une communauté qui repose sur la confiance. Pour établir ce rapport de confiance, 
                il est fondamental de faire preuve de transparence quant à la manière dont nous utilisons vos informations.
              </p>
              <p className="help-text">
                Nous traitons les informations collectées lors de la vérification d'identité aux fins décrites dans notre
                <a target='_blank' className="link" href={`/topics/about/62`}>Politique de confidentialité.</a> 
                Découvrez <a target='_blank' className="link" href={`#`}>comment nous gérons et communiquons vos données.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicConditionInscription